import { c as _c } from "react/compiler-runtime";
import { Google, Microsoft, SvgIconComponent } from "@mui/icons-material";
import CircularProgress from "@mui/material/CircularProgress";
import IconButton from "@mui/material/IconButton";
import { useCallback } from "react";
import { useCalendarQueries } from "@/queries/events/calendar-queries";
interface CalendarModalLayoutProps {
  clubSlug: string;
}
interface CalendarButtonProps {
  label: string;
  icon: SvgIconComponent;
  disabled?: boolean;
  baseIcsUrl: string;
  provider: CalendarProvider;
}
enum CalendarProvider {
  Google = "google",
  Outlook = "outlook",
}
function getCalendarSubscriptionLinks(icsUrl: string, type: CalendarProvider) {
  const iCalIcsUrl = icsUrl.replace(/^https?:\/\//, "webcal://");
  const encodedIcsUrl = encodeURIComponent(iCalIcsUrl);
  const outlookIcsUrl = `https://outlook.office.com/calendar/0/addcalendar?url=${encodedIcsUrl}`;
  const googleAgendaUrl = `https://calendar.google.com/calendar/r?cid=${encodedIcsUrl}`;
  switch (type) {
    case CalendarProvider.Outlook:
      return outlookIcsUrl;
    case CalendarProvider.Google:
      return googleAgendaUrl;
    default:
      return icsUrl;
  }
}
const CalendarButton = t0 => {
  const $ = _c(23);
  const {
    label,
    baseIcsUrl,
    provider,
    disabled: t1,
    icon: Icon
  } = t0;
  const disabled = t1 === undefined ? false : t1;
  let t2;
  if ($[0] !== baseIcsUrl || $[1] !== provider) {
    t2 = getCalendarSubscriptionLinks(baseIcsUrl, provider);
    $[0] = baseIcsUrl;
    $[1] = provider;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const href = t2;
  let t3;
  if ($[3] !== href) {
    t3 = () => {
      window.open(href, "_blank");
    };
    $[3] = href;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const handleOnClick = t3;
  let t4;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      height: 72,
      width: 72
    };
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {
      height: 32,
      width: 32
    };
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== Icon) {
    t6 = <Icon sx={t5} fontSize="inherit" />;
    $[7] = Icon;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== disabled || $[10] !== handleOnClick || $[11] !== label || $[12] !== t6) {
    t7 = <IconButton sx={t4} onClick={handleOnClick} aria-label={label} disabled={disabled} title={label}>{t6}</IconButton>;
    $[9] = disabled;
    $[10] = handleOnClick;
    $[11] = label;
    $[12] = t6;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  const t8 = disabled ? "opacity-50" : "";
  let t9;
  if ($[14] !== label || $[15] !== t8) {
    t9 = <p className={t8}>{label}</p>;
    $[14] = label;
    $[15] = t8;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  let t10;
  if ($[17] !== disabled) {
    t10 = disabled && <p className="opacity-50">(prochainement)</p>;
    $[17] = disabled;
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  let t11;
  if ($[19] !== t10 || $[20] !== t7 || $[21] !== t9) {
    t11 = <div className="flex-col justify-center items-center text-center gap-2">{t7}{t9}{t10}</div>;
    $[19] = t10;
    $[20] = t7;
    $[21] = t9;
    $[22] = t11;
  } else {
    t11 = $[22];
  }
  return t11;
};
const CalendarModalLayout = t0 => {
  const $ = _c(8);
  const {
    clubSlug
  } = t0;
  const {
    isLoading,
    data,
    isError,
    refetch
  } = useCalendarQueries(clubSlug);
  const hasValidUrl = Boolean(data !== undefined && typeof (data as any).url === "string" && (data as any).url.length > 0);
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <h3 className="text-center mb-5">Sélectionnez votre application de calendrier pour ajouter vos réunions</h3>;
    t2 = <p className="text-center text-sm text-neutral-500 mb-4">Seules les réunions des 6 prochains mois sont incluses.</p>;
    $[0] = t1;
    $[1] = t2;
  } else {
    t1 = $[0];
    t2 = $[1];
  }
  let t3;
  if ($[2] !== data || $[3] !== hasValidUrl || $[4] !== isError || $[5] !== isLoading || $[6] !== refetch) {
    t3 = <div className="flex-col gap-4 items-start justify-center p-10">{t1}{t2}<div className="flex gap-10 justify-center">{isLoading ? <div className="col gap-2 flex flex-col items-center justify-center"><CircularProgress color="inherit" size={50} /><p className="text-center">Génération du calendrier</p></div> : isError ? <div className="col gap-3 flex flex-col items-center justify-center text-center"><p className="text-red-600">Une erreur est survenue lors de la génération du calendrier.</p><button type="button" onClick={() => refetch()} className="px-4 py-2 rounded-md bg-neutral-900 text-white hover:bg-neutral-800">Réessayer</button></div> : <>{hasValidUrl && data !== undefined && <><CalendarButton baseIcsUrl={data.url} provider={CalendarProvider.Outlook} label="Outlook" icon={Microsoft} /><CalendarButton baseIcsUrl={data.url} provider={CalendarProvider.Google} label="Google Agenda" icon={Google} /></>}{!hasValidUrl && <p className="text-center text-sm text-neutral-600">Aucun lien de calendrier disponible pour le moment.</p>}</>}</div></div>;
    $[2] = data;
    $[3] = hasValidUrl;
    $[4] = isError;
    $[5] = isLoading;
    $[6] = refetch;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  return t3;
};
export default CalendarModalLayout;